module.exports = __webpack_public_path__ + "static/img/ent-52.e623c30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-52.jpg
// module id = VKQ+
// module chunks = 52